import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Treatments } from '../components/Treatments';
import { Institute } from '../components/Institute';
import { Reviews } from '../components/Reviews';
import { GiftCard } from '../components/GiftCard';
import { Footer } from '../components/Footer';
import { MobileBookingBar } from '../components/MobileBookingBar';
export function Home() {
  return <div className="min-h-screen w-full bg-white" data-id="element-142" data-mp="1zjs5nruxej3g">
      <Header data-id="element-143" data-mp="24gimihek1ipx" />
      <main data-id="element-144" data-mp="24i3fi2l80tlo">
        <Hero data-id="element-145" data-mp="24htp4dw9kkfg" />
        <Institute data-id="element-146" data-mp="24haivufz7kh9" />
        <Treatments data-id="element-147" data-mp="24ivbheiqctch" />
        <Reviews data-id="element-148" data-mp="29gdeypdzagd3" />
        <GiftCard data-id="element-149" data-mp="29fvfzkzxlo1h" />
      </main>
      <Footer data-id="element-150" data-mp="29etuemlahj5i" />
      <MobileBookingBar data-id="element-151" data-mp="29i7v7qeb1kau" />
    </div>;
}